export const iconFontAwesomeHumanitarianSackXmark = (
	<i className="fa-solid fa-sack-xmark"></i>
);
